<template>
  <div class="trigger trigger-section">
    <div class="trigger-section-header trigger-section-header-orange">
      <b-icon icon="bar-chart-fill" />
      <span>{{ $t('configuracao-dos-gatilhos-de-media') }}</span>
    </div>
    <div class="trigger-section-body">

      <!-- Linha 1: VMD, VMW_RTA / VMT, AMH -->
      <div class="trigger-cards-row">

        <!-- VMD: Dias Sem Média Atingir Meta -->
        <div class="trigger-card" :class="{ 'trigger-card--inactive': !vmdActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-10" v-model="vmdActive" @change="sendVMD" class="trigger-checkBox" name="checkbox-10" value="true" switch :title="$t('dias-sem-media-atingir-meta')" v-marquee-overflow>
              {{ $t('dias-sem-media-atingir-meta') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VMD.title + ' - ' + triggerInfo.VMD.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.VMD.title + ' - ' + $t('explicacao-fca-9') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="vmd-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input type="number" id="vmd-unconformities" v-model="vmdUnconformities" @keyup="sendVMD" @change="sendVMD"
                placeholder="1" min="1" @input="handleInput('vmdUnconformities', $event)" style="width: 60px;" />
            </span>
          </div>
        </div>

        <!-- VMW_RTA: Semana Sem Média Atingir Meta (RTA) -->
        <div v-if="isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !vmwRtaActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-vmw-rta" v-model="vmwRtaActive" @change="sendVMW_RTA" class="trigger-checkBox" name="checkbox-vmw-rta" value="true" switch :title="$t('semana-sem-media-atingir-meta')" v-marquee-overflow>
              {{ $t('semana-sem-media-atingir-meta') }}
            </b-form-checkbox>
            <b-icon v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.VMW_RTA.title.replace('_RTA', '') + ' - ' + $t('explicacao-vmw-rta') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="vmw-rta-unconformities">{{ $t('qtd-semanas') }}</label>
              <b-form-input type="number" id="vmw-rta-unconformities" v-model="vmwRtaUnconformities" @keyup="sendVMW_RTA" @change="sendVMW_RTA"
                placeholder="1" min="1" @input="handleInput('vmwRtaUnconformities', $event)" style="width: 60px;" />
            </span>
            <span class="trigger-field">
              <label for="vmw-rta-week-start">{{ $t('inicio-semana') }}</label>
              <b-form-select id="vmw-rta-week-start" v-model="vmwRtaWeekStartDay" @change="sendVMW_RTA" style="width: 110px;">
                <b-form-select-option :value="0">Domingo</b-form-select-option>
                <b-form-select-option :value="1">Segunda</b-form-select-option>
                <b-form-select-option :value="2">Terça</b-form-select-option>
                <b-form-select-option :value="3">Quarta</b-form-select-option>
                <b-form-select-option :value="4">Quinta</b-form-select-option>
                <b-form-select-option :value="5">Sexta</b-form-select-option>
                <b-form-select-option :value="6">Sábado</b-form-select-option>
              </b-form-select>
            </span>
          </div>
        </div>

        <!-- VMT: Dias Sem Média Atingir Meta do Turno -->
        <div v-if="!isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !vmtActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-11" v-model="vmtActive" @change="sendVMT" class="trigger-checkBox" name="checkbox-11" value="true" switch :title="$t('dias-sem-media-atingir-meta-do-turno')" v-marquee-overflow>
              {{ $t('dias-sem-media-atingir-meta-do-turno') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VMT.title + ' - ' + triggerInfo.VMT.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.VMT.title + ' - ' + $t('explicacao-fca-10') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="vmt-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input type="number" id="vmt-unconformities" v-model="vmtUnconformities" @keyup="sendVMT" @change="sendVMT"
                placeholder="1" min="1" @input="handleInput('vmtUnconformities', $event)" style="width: 60px;" />
            </span>
          </div>
        </div>

        <!-- AMH: Média de Aderência Horária Fora da Meta -->
        <div v-if="!isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !amhActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-12" v-model="amhActive" @change="sendAMH" class="trigger-checkBox" name="checkbox-12" value="true" switch :title="$t('media-de-aderencia-horaria-fora-da-meta')" v-marquee-overflow>
              {{ $t('media-de-aderencia-horaria-fora-da-meta') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.AMH.title + ' - ' + triggerInfo.AMH.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.AMH.title + ' - ' + $t('explicacao-fca-11') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="amh-minutes">{{ $t('intervalo') }}</label>
              <b-form-input type="number" id="amh-minutes" v-model="minutes" @keyup="sendAMH" @change="sendAMH"
                placeholder="1" @input="handleInput('minutes', $event)" min="1" style="width: 60px;" />
              <label for="amh-minutes">{{ show ? $t('days') : $t('minutos') }}</label>
            </span>
          </div>
        </div>

      </div>

      <!-- Linha 2: VMH, VMW -->
      <div v-if="!isRta" class="trigger-cards-row trigger-cards-row--mt">

        <!-- VMH: Tempo Sem Atingir a Média de Valor do Indicador -->
        <div class="trigger-card" :class="{ 'trigger-card--inactive': !vmhActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-13" v-model="vmhActive" @change="sendVMH" class="trigger-checkBox" name="checkbox-13" value="true" switch :title="$t('tempo-sem-atingir-a-media-de-valor-do-indicador')" v-marquee-overflow>
              {{ $t('tempo-sem-atingir-a-media-de-valor-do-indicador') }}
            </b-form-checkbox>
            <b-icon @click="() => showInfo(triggerInfo.VMH.title + ' - ' + triggerInfo.VMH.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="vmh-minutes">{{ $t('intervalo-min') }}</label>
              <b-form-input type="number" id="vmh-minutes" v-model="vmhMinutes" @keyup="sendVMH" @change="sendVMH"
                placeholder="60" style="width: 60px;" min="1" />
            </span>
            <span class="trigger-field">
              <input type="checkbox" class="trigger-sm-check" v-model="vmhMinActive" @change="sendVMH" />
              <span>{{ $t('min') }}</span>
              <b-form-input type="number" id="vmh-min" v-model="vmhMinValue" @keyup="sendVMH" @change="sendVMH"
                placeholder="0" style="width: 65px;" :disabled="!vmhMinActive" />
            </span>
            <span class="trigger-field">
              <input type="checkbox" class="trigger-sm-check" v-model="vmhMaxActive" @change="sendVMH" />
              <span>{{ $t('max') }}</span>
              <b-form-input type="number" id="vmh-max" v-model="vmhMaxValue" @keyup="sendVMH" @change="sendVMH"
                placeholder="9999" style="width: 65px;" :disabled="!vmhMaxActive" />
            </span>
          </div>
        </div>

        <!-- VMW: Média do Turno Fora do Limite -->
        <div class="trigger-card" :class="{ 'trigger-card--inactive': !vmwActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-14" v-model="vmwActive" @change="sendVMW" class="trigger-checkBox" name="checkbox-14" value="true" switch :title="$t('media-do-turno-fora-do-limite')" v-marquee-overflow>
              {{ $t('media-do-turno-fora-do-limite') }}
            </b-form-checkbox>
            <b-icon @click="() => showInfo(triggerInfo.VMW.title + ' - ' + triggerInfo.VMW.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <input type="checkbox" class="trigger-sm-check" v-model="vmwMinActive" @change="sendVMW" />
              <span>{{ $t('min') }}</span>
              <b-form-input type="number" id="vmw-min" v-model="vmwMinValue" @keyup="sendVMW" @change="sendVMW"
                placeholder="0" style="width: 65px;" :disabled="!vmwMinActive" />
            </span>
            <span class="trigger-field">
              <input type="checkbox" class="trigger-sm-check" v-model="vmwMaxActive" @change="sendVMW" />
              <span>{{ $t('max') }}</span>
              <b-form-input type="number" id="vmw-max" v-model="vmwMaxValue" @keyup="sendVMW" @change="sendVMW"
                placeholder="9999" style="width: 65px;" :disabled="!vmwMaxActive" />
            </span>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import MediatorTrigger from "../tools/MediatorTrigger"

export default {
  name: "TriggerAverageValue",
  props: ["triggerInfo", "reset", "triggerSelected", "show", "isRta"],
  inject: ["showInfo", "showResponsibles"],
  data() {
    return {
      vmdActive: false,
      vmdUnconformities: 1,

      vmtActive: false,
      vmtUnconformities: 1,

      amhActive: false,
      minutes: 60,
      daysConverted: 0,

      vmhActive: false,
      vmhMinValue: 0,
      vmhMaxValue: 9999,
      vmhMinutes: 60,
      vmhMinActive: false,
      vmhMaxActive: false,

      vmwActive: false,
      vmwMinValue: 0,
      vmwMaxValue: 9999,
      vmwMinActive: false,
      vmwMaxActive: false,

      vmwRtaActive: false,
      vmwRtaUnconformities: 1,
      vmwRtaWeekStartDay: 1,

    }
  },

  watch: {
    reset() {
      this.resetForm()
    },
  },

  methods: {
    loadForm(value) {
      if (!value.VMD) return
      this.loadData(value)
    },

    sendVMD() {
      MediatorTrigger.notify({
        active: this.vmdActive,
        unconformities: this.vmdUnconformities
      }, "setVMD")
    },

    sendVMT() {
      MediatorTrigger.notify({
        active: this.vmtActive,
        unconformities: this.vmtUnconformities
      }, "setVMT")
    },

    sendAMH() {
      if (this.show) {
        this.daysConverted = (this.minutes * 1440)

        MediatorTrigger.notify({
          active: this.amhActive,
          minutes: this.daysConverted
        }, "setAMH")
      } else {
        MediatorTrigger.notify({
          active: this.amhActive,
          minutes: this.minutes
        }, "setAMH")
      }
    },

    sendVMH() {
      if (this.show) {
        this.daysConverted = (this.vmhMinutes * 1440);
        MediatorTrigger.notify({
          active: this.vmhActive,
          minValue: this.vmhMinValue,
          maxValue: this.vmhMaxValue,
          minutes: this.daysConverted,
          minActive: this.vmhMinActive,
          maxActive: this.vmhMaxActive
        }, "setVMH")
      } else {
        MediatorTrigger.notify({
          active: this.vmhActive,
          minValue: this.vmhMinValue,
          maxValue: this.vmhMaxValue,
          minutes: this.vmhMinutes,
          minActive: this.vmhMinActive,
          maxActive: this.vmhMaxActive
        }, "setVMH")
      }
    },

    sendVMW() {
      MediatorTrigger.notify({
        active: this.vmwActive,
        minValue: this.vmwMinValue,
        maxValue: this.vmwMaxValue,
        minActive: this.vmwMinActive,
        maxActive: this.vmwMaxActive
      }, "setVMW");
    },

    sendVMW_RTA() {
      MediatorTrigger.notify({
        active: this.vmwRtaActive,
        unconformities: this.vmwRtaUnconformities,
        weekStartDay: this.vmwRtaWeekStartDay
      }, "setVMW_RTA");
    },

    async loadData(value) {
      await this.resetForm()
      this.vmdActive = value.VMD.active;
      if (value.VMD.configurationJSON) {
        let configurationJSON = JSON.parse(value.VMD.configurationJSON)
        this.vmdUnconformities = configurationJSON.unconformities;
      }

      this.vmtActive = value.VMT.active;
      if (value.VMT.configurationJSON) {
        let configurationJSON = JSON.parse(value.VMT.configurationJSON)
        this.vmtUnconformities = configurationJSON.unconformities;
      }

      this.amhActive = value.AMH.active;
      if (value.AMH.configurationJSON) {
        let configurationJSON = JSON.parse(value.AMH.configurationJSON)
        if (this.show) {
          this.minutes = configurationJSON.minutes / 1440;
        } else {
          this.minutes = configurationJSON.minutes;
        }
      }

      this.vmhActive = value.VMH.active;
      if (value.VMH.configurationJSON) {
        let configurationJSON = JSON.parse(value.VMH.configurationJSON)
        this.vmhMinValue = configurationJSON.minValue;
        this.vmhMaxValue = configurationJSON.maxValue;
        this.vmhMinActive = configurationJSON.minActive;
        this.vmhMaxActive = configurationJSON.maxActive;
        if (this.show) {
          this.vmhMinutes = configurationJSON.minutes / 1440;
        } else {
          this.vmhMinutes = configurationJSON.minutes;
        }
      }

      if (value.VMW) {
        this.vmwActive = value.VMW.active;
        if (value.VMW.configurationJSON) {
          let configurationJSON = JSON.parse(value.VMW.configurationJSON)
          this.vmwMinValue = configurationJSON.minValue;
          this.vmwMaxValue = configurationJSON.maxValue;
          this.vmwMinActive = configurationJSON.minActive;
          this.vmwMaxActive = configurationJSON.maxActive;
        }
      }

      // VMW_RTA
      if (value.VMW_RTA) {
        this.vmwRtaActive = value.VMW_RTA.active;
        if (value.VMW_RTA.configurationJSON) {
          let configurationJSON = JSON.parse(value.VMW_RTA.configurationJSON)
          this.vmwRtaUnconformities = configurationJSON.unconformities || 1;
          this.vmwRtaWeekStartDay = configurationJSON.weekStartDay ?? 1;
        }
      }
    },

    resetForm() {
      this.vmdActive = false;
      this.vmdUnconformities = 1;
      this.vmtActive = false;
      this.vmtUnconformities = 1;
      this.amhActive = false;

      if (this.show) {
        this.minutes = 1;
        this.vmhMinutes = 1;
      } else {
        this.minutes = 60;
        this.vmhMinutes = 60;
      }

      this.daysConverted = 0;
      this.vmhActive = false;
      this.vmhMinValue = 0;
      this.vmhMaxValue = 60;
      this.vmhMinActive = false;
      this.vmhMaxActive = false;

      this.vmwActive = false;
      this.vmwMinValue = 0;
      this.vmwMaxValue = 60;
      this.vmwMinActive = false;
      this.vmwMaxActive = false;

      this.vmwRtaActive = false;
      this.vmwRtaUnconformities = 1;
      this.vmwRtaWeekStartDay = 1;
    },

    handleInput(prop, event) {
      let cleanedValue = event.replace(/\D/g, '');
      if (prop == 'vmdUnconformities')
        this.vmdUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else if (prop == 'vmtUnconformities')
        this.vmtUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else if (prop == 'vmwRtaUnconformities')
        this.vmwRtaUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else{
        this.minutes = cleanedValue !== '' ? parseInt(cleanedValue) : null;
        this.vmhMinutes = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      }
    }
  },

  mounted() {
    console.log("TriggerAverageValue - isRta:", this.isRta);
    if (this.show) {
      this.minutes = 1;
      this.vmhMinutes = 1;

    }

    MediatorTrigger.notify(this, "initTriggerAverageValue")
  }
}
</script>

<style scoped src="../style.css"></style>